import { on } from 'js/lib/events'
import { createAnalyticsGroup } from 'js/lib/analytics'

on('click', '.js-c-listings-form-controls--tracking', event => {
  const track = createAnalyticsGroup(event.target.getAttribute('data-category'))
  const clickValue = event.target.getAttribute('data-click');
  track('click', clickValue)
})
